import { alphartisApiAxios } from "@/config/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  ELECTRONIC_SIGNATURE_TEMPLATE_CONFIGURATION_API_PATH,
  ELECTRONIC_SIGNATURE_TEMPLATE_CONFIGURATION_RESOURCE,
} from "./electronic-signature-template-configuration.types";

export function useElectronicSignatureTemplateConfigurationDeleteMutation() {
  const queryClient = useQueryClient();

  return useMutation<void, Error, { uuid: string }>({
    mutationFn: async ({ uuid }) => {
      await alphartisApiAxios.delete<void>(`${ELECTRONIC_SIGNATURE_TEMPLATE_CONFIGURATION_API_PATH}/${uuid}`);
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [ELECTRONIC_SIGNATURE_TEMPLATE_CONFIGURATION_RESOURCE],
      });
    },
  });
}
